import React, { useState, useEffect } from "react";
import SeoHead from "../components/SeoHead";
import DogGroomingForm from "../components/DogGroomingForm";
import { BUSINESS_INFO, IMAGES, GALLERIES, VERBATIM_TEXTS, PRODUCTS_AND_EQUIPMENT } from "../data";
import DogPricingTable from "../components/DogPricingTable";

export default function HundeklipVask() {
  const [galleryImages, setGalleryImages] = useState(GALLERIES[2].images);
  const [selectedLightboxIndex, setSelectedLightboxIndex] = useState(null);

  useEffect(() => {
    fetch("/_api/public/v2/content/gallery?slug=hundeklip")
      .then((res) => res.json())
      .then((data) => {
        if (data?.items?.[0]?.images && Array.isArray(data.items[0].images) && data.items[0].images.length > 0) {
          setGalleryImages(data.items[0].images);
        }
      })
      .catch(() => {
        // Fallback to initial mock data
      });
  }, []);

  const openLightbox = (index) => setSelectedLightboxIndex(index);
  const closeLightbox = () => setSelectedLightboxIndex(null);

  const prevImage = (e) => {
    e?.stopPropagation();
    setSelectedLightboxIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };

  const nextImage = (e) => {
    e?.stopPropagation();
    setSelectedLightboxIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <SeoHead
        title="Hundeklip & vask"
        description="Hos Ses Multi Service tilbyder vi kærlig og skånsom klip og vask af små hunde under 10 kg. Faste aftaler om pelspleje for en tryg oplevelse."
        path="/hundeklip-og-vask"
      />

      {/* SUBPAGE HERO - Soft warm character */}
      <section className="bg-gradient-to-b from-[#F4EFE6] via-[#FAF7F2] to-[#FAF7F2] py-12 lg:py-20 border-b border-[#EADFCF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            
            <div className="lg:col-span-6 space-y-5">
              <div className="inline-flex items-center gap-2 bg-[#EADFCF] text-[#4B3C2D] px-3.5 py-1 rounded-full text-xs font-semibold">
                <i className="fa-solid fa-dog text-[#887055]" aria-hidden="true"></i>
                <span>Gælder hunde under 10 kg</span>
              </div>

              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-heading text-[#2C2523] leading-[1.15]">
                Hunde bad og klip
              </h1>

              <p className="text-base sm:text-lg text-[#5C524C] leading-relaxed max-w-2xl">
                Kærlig og omhyggelig pelspleje i trygge og rolige rammer.
              </p>

              <div className="flex flex-wrap items-center gap-4 pt-2">
                <a
                  href={`tel:${BUSINESS_INFO.phone}`}
                  className="bg-[#3A302B] hover:bg-[#231C19] text-[#FFFDF9] px-6 py-3.5 rounded-xl font-semibold text-sm transition-colors flex items-center gap-2 whitespace-nowrap shadow-sm hover:shadow-md"
                >
                  <i className="fa-solid fa-phone text-xs" aria-hidden="true"></i>
                  <span className="whitespace-nowrap">Ring på 40 94 75 40</span>
                </a>
                <a
                  href="#priser"
                  className="bg-white hover:bg-[#FAF7F2] text-[#2C2523] px-5 py-3.5 rounded-xl font-semibold text-sm transition-colors border border-[#D8C7B0] shadow-2xs flex items-center gap-2"
                >
                  <i className="fa-solid fa-tags text-xs text-[#887055]" aria-hidden="true"></i>
                  <span>Se prisliste</span>
                </a>
                <a
                  href="#hundeklip-form"
                  className="bg-[#EADFCF] hover:bg-[#D8C7B0] text-[#2C2523] px-6 py-3.5 rounded-xl font-semibold text-sm transition-colors border border-[#D8C7B0] shadow-2xs"
                >
                  Bestil tid
                </a>
              </div>
            </div>

            <div className="lg:col-span-6">
              <div className="rounded-3xl overflow-hidden border border-[#EADFCF] shadow-xl bg-white relative">
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  poster={IMAGES.dogGrooming}
                  className="w-full h-[360px] sm:h-[440px] lg:h-[500px] xl:h-[540px] object-cover"
                >
                  <source src="https://assets.auxodev.dk/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/shutterstock-1108388841.mov" type="video/mp4" />
                  <source src="https://assets.auxodev.dk/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/shutterstock-1108388841.mov" type="video/quicktime" />
                  Din browser understøtter ikke videoafspilning.
                </video>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* VERBATIM CUSTOMER COPY SECTION */}
      <section className="py-14 lg:py-20 bg-[#FAF7F2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div className="sand-card-light rounded-3xl p-8 sm:p-12 border border-[#EADFCF] shadow-xs space-y-6">
            <div className="flex items-center gap-3 border-b border-[#EADFCF] pb-4">
              <div className="w-10 h-10 rounded-xl bg-[#EADFCF] text-[#6B5640] flex items-center justify-center text-lg">
                <i className="fa-solid fa-paw" aria-hidden="true"></i>
              </div>
              <div>
                <h2 className="text-xl font-bold font-heading text-[#2C2523]">
                  Hunde bad og klip
                </h2>
                <p className="text-xs text-[#887055] font-medium">Til hunde under 10 kg</p>
              </div>
            </div>

            {/* EXACT VERBATIM CUSTOMER COPY */}
            <div className="text-base text-[#2C2523] leading-relaxed space-y-4 font-normal">
              <p>
                Hos Ses Multi Service tilbyder jeg klip og vask af din hund under 10 kg.
              </p>
              <p>
                Lav en fast aftale, så din hunds pels bliver velplejet og nem at håndtere.
              </p>
              <p className="font-semibold text-[#3A302B]">
                Jeg sikrer en tryg og behagelig oplevelse for din firbenede ven!
              </p>
            </div>

            <div className="pt-6 border-t border-[#EADFCF] grid grid-cols-1 sm:grid-cols-3 gap-4 text-xs text-[#5C524C]">
              <div className="bg-[#FAF7F2] p-3 rounded-xl border border-[#EADFCF] flex items-center gap-2">
                <i className="fa-solid fa-weight-hanging text-[#887055]" aria-hidden="true"></i>
                <span>Kun hunde under 10 kg</span>
              </div>
              <div className="bg-[#FAF7F2] p-3 rounded-xl border border-[#EADFCF] flex items-center gap-2">
                <i className="fa-solid fa-calendar-alt text-[#887055]" aria-hidden="true"></i>
                <span>Mulighed for faste aftaler</span>
              </div>
              <div className="bg-[#FAF7F2] p-3 rounded-xl border border-[#EADFCF] flex items-center gap-2">
                <i className="fa-solid fa-heart text-[#887055]" aria-hidden="true"></i>
                <span>Tryg & rolig oplevelse</span>
              </div>
            </div>

            {/* Tidsbestilling punkter */}
            <div className="p-4 bg-[#FAF7F2] rounded-2xl border border-[#EADFCF] space-y-2">
              <span className="text-xs font-bold uppercase tracking-wider text-[#887055] block">
                Bestilling af hundeklip:
              </span>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 text-xs text-[#2C2523] font-medium">
                <div className="flex items-center gap-2 bg-white/80 p-2.5 rounded-xl border border-[#EADFCF]">
                  <i className="fa-solid fa-calendar-day text-[#887055]" aria-hidden="true"></i>
                  <span>Åben tirsdag til torsdag i hver uge</span>
                </div>
                <div className="flex items-center gap-2 bg-white/80 p-2.5 rounded-xl border border-[#EADFCF]">
                  <i className="fa-solid fa-calendar-xmark text-[#887055]" aria-hidden="true"></i>
                  <span>Lukket alle helligdage</span>
                </div>
                <div className="flex items-center gap-2 bg-white/80 p-2.5 rounded-xl border border-[#EADFCF]">
                  <i className="fa-solid fa-clock text-[#887055]" aria-hidden="true"></i>
                  <span>Mellem 9 og 15</span>
                </div>
                <div className="flex items-center gap-2 bg-white/80 p-2.5 rounded-xl border border-[#EADFCF]">
                  <i className="fa-solid fa-calendar-days text-[#887055]" aria-hidden="true"></i>
                  <span>Sep okt nov dec jan</span>
                </div>
              </div>
            </div>

            {/* Products Box */}
            <div className="pt-6 border-t border-[#EADFCF] space-y-4">
              <div className="bg-[#FAF7F2] p-6 rounded-2xl border border-[#EADFCF] space-y-4">
                <div className="flex items-center gap-2.5 text-[#2C2523] font-bold font-heading">
                  <i className="fa-solid fa-paw text-[#887055]"></i>
                  <span>Skånsomme plejeprodukter til din hund</span>
                </div>
                <p className="text-sm text-[#4A403A]">
                  Vi bruger milde, skånsomme og plejende produkter, der passer godt på din hunds hud og pels.
                </p>
                <div>
                  <span className="text-xs font-bold uppercase tracking-wider text-[#887055] block mb-2">
                    {PRODUCTS_AND_EQUIPMENT.dogCareHeading}
                  </span>
                  <div className="flex flex-wrap gap-3">
                    {PRODUCTS_AND_EQUIPMENT.dogCareLinks.map((item, idx) => (
                      <a
                        key={idx}
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-xs font-semibold text-[#2C2523] bg-white hover:bg-[#FFFDF9] px-3.5 py-2 rounded-lg border border-[#D8C7B0] hover:border-[#887055] transition-colors shadow-2xs group"
                      >
                        <span>{item.url}</span>
                        <i className="fa-solid fa-arrow-up-right-from-square text-[10px] text-[#887055]" aria-hidden="true"></i>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* GALLERY SECTION WITH VIDEO & IMAGES */}
      <section className="py-14 lg:py-20 bg-[#F4EFE6] border-y border-[#EADFCF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            <div className="space-y-2">
              <div className="inline-flex items-center gap-2 bg-[#EADFCF] text-[#4B3C2D] px-3.5 py-1 rounded-full text-xs font-semibold">
                <i className="fa-solid fa-camera text-[#887055]" aria-hidden="true"></i>
                <span>Billeder & Video</span>
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold font-heading text-[#2C2523]">
                Galleri – Hundeklip & Vask
              </h2>
              <p className="text-sm sm:text-base text-[#5C524C]">
                Billeder og video fra vores kærlige pelspleje af små hunde under 10 kg.
              </p>
            </div>

            {/* Video beside images grid */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch">
              {/* Featured Gallery Video */}
              <div className="lg:col-span-6 flex flex-col">
                <div className="rounded-2xl overflow-hidden border border-[#EADFCF] bg-white shadow-md relative flex-1 min-h-[300px] sm:min-h-[380px] lg:min-h-[420px] group">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    className="w-full h-full min-h-[300px] sm:min-h-[380px] lg:min-h-[420px] object-cover"
                  >
                    <source src="https://assets.auxodev.dk/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/shutterstock-3600357181.mov" type="video/mp4" />
                    <source src="https://assets.auxodev.dk/assets/161db869-3b85-456e-973a-3a2fd3e99bfc/shutterstock-3600357181.mov" type="video/quicktime" />
                    Din browser understøtter ikke videoafspilning.
                  </video>
                  <div className="absolute top-4 left-4 bg-[#2C2523]/80 backdrop-blur-md text-[#FAF7F2] px-3.5 py-1.5 rounded-full text-xs font-semibold flex items-center gap-2 shadow-md">
                    <i className="fa-solid fa-circle-play text-[#D8C7B0] text-sm" aria-hidden="true"></i>
                    <span>Klip&nbsp; i aktion</span>
                  </div>
                </div>
              </div>

              {/* Gallery Images Grid */}
              <div className="lg:col-span-6 flex flex-col justify-between gap-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 h-full">
                  {galleryImages.map((item, idx) => {
                    const imgUrl = typeof item === "string" ? item : item.url;
                    const caption = typeof item === "object" ? item.caption : "";

                    return (
                      <div
                        key={idx}
                        onClick={() => openLightbox(idx)}
                        className="group relative h-64 sm:h-full min-h-[200px] rounded-2xl overflow-hidden border border-[#EADFCF] bg-[#FAF7F2] cursor-pointer shadow-sm hover:shadow-md transition-all duration-300 flex flex-col"
                      >
                        <img
                          src={imgUrl}
                          alt={caption || `Galleri billede ${idx + 1}`}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#2C2523]/75 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                          <div className="flex items-center justify-between w-full text-white text-xs">
                            <span className="font-medium drop-shadow-sm">{caption || "Klik for at forstørre"}</span>
                            <div className="w-8 h-8 rounded-full bg-[#FAF7F2]/30 backdrop-blur-md flex items-center justify-center text-white">
                              <i className="fa-solid fa-expand" aria-hidden="true"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Lightbox Modal */}
            {selectedLightboxIndex !== null && (
              <div
                className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-200"
                onClick={closeLightbox}
              >
                {/* Close button */}
                <button
                  type="button"
                  onClick={closeLightbox}
                  className="absolute top-4 right-4 z-50 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors cursor-pointer text-lg"
                  aria-label="Luk galleri"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </button>

                {/* Prev button */}
                {galleryImages.length > 1 && (
                  <button
                    type="button"
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 -translate-y-1/2 z-50 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors cursor-pointer text-xl"
                    aria-label="Forrige billede"
                  >
                    <i className="fa-solid fa-chevron-left" aria-hidden="true"></i>
                  </button>
                )}

                {/* Image & Caption */}
                <div
                  className="max-w-5xl max-h-[85vh] flex flex-col items-center justify-center"
                  onClick={(e) => e.stopPropagation()}
                >
                  <img
                    src={typeof galleryImages[selectedLightboxIndex] === "string" ? galleryImages[selectedLightboxIndex] : galleryImages[selectedLightboxIndex].url}
                    alt="Galleri forstørrelse"
                    className="max-w-full max-h-[75vh] object-contain rounded-xl shadow-2xl"
                  />
                  {typeof galleryImages[selectedLightboxIndex] === "object" && galleryImages[selectedLightboxIndex].caption && (
                    <p className="mt-4 text-sm font-medium text-white/90 bg-black/40 px-4 py-2 rounded-full backdrop-blur-md">
                      {galleryImages[selectedLightboxIndex].caption}
                    </p>
                  )}
                  <p className="mt-2 text-xs text-white/60">
                    {selectedLightboxIndex + 1} af {galleryImages.length}
                  </p>
                </div>

                {/* Next button */}
                {galleryImages.length > 1 && (
                  <button
                    type="button"
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 -translate-y-1/2 z-50 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors cursor-pointer text-xl"
                    aria-label="Næste billede"
                  >
                    <i className="fa-solid fa-chevron-right" aria-hidden="true"></i>
                  </button>
                )}
              </div>
            )}

          </div>
        </div>
      </section>

      {/* PRICING TABLE COMPONENT CONNECTED TO CMS */}
      <DogPricingTable />

      {/* DEDICATED DOG GROOMING FORM SECTION */}
      <section id="hundeklip-form" className="py-16 lg:py-24 bg-[#FAF7F2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <DogGroomingForm />
        </div>
      </section>
    </>
  );
}
